import React, { ComponentProps, JSX } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@chakra-ui/react';

import { useKioskAwareUrl } from '../../../utils/kioskMode';

type LinkButtonProps = {
  isDownload?: boolean;
  to: string;
};

export const LinkButton = ({
  to,
  children,
  isDownload,
  ...props
}: ComponentProps<typeof Button> & LinkButtonProps): JSX.Element => {
  const getKioskAwareUrl = useKioskAwareUrl();

  const LinkElement = (isDownload ? 'a' : Link) as keyof JSX.IntrinsicElements;
  const finalUrl = isDownload ? to : getKioskAwareUrl(to);
  const elementProps = isDownload ? { href: to, download: true } : { to: finalUrl };

  return (
    <>
      <LinkElement {...elementProps}>
        <Button {...props}>{children}</Button>
      </LinkElement>
    </>
  );
};
